import React from 'react'

import { SwiperSlide } from 'swiper/react'

import { Banner } from '@/organisms'
import BaseCarousel from '../../molecules/BaseCarousel'

const BannerCarousel = ({ items, colorScheme }) => {
  return (
    <BaseCarousel
      swiperProps={{
        spaceBetween: 24,
        slidesPerView: 1,
      }}
    >
      {items.map((item, i) => {
        return (
          <SwiperSlide key={i}>
            <Banner
              {...item}
              colorScheme={colorScheme}
              isSwiper={true}
            />
          </SwiperSlide>
        )
      })}
    </BaseCarousel>
  )
}

export default BannerCarousel
